export const GoogleMapApiConfig = 'AIzaSyB6l9L4tCFRW7feJS7etwqd6lmLqeYbQio';